// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/Barlow-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/Barlow-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/Nelphim.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../images/VisionMissionBG.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Barlow";
  src: local("Barlow"), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff");
}

@font-face {
  font-family: "BarlowBold";
  src: local("BarlowBold"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
}

@font-face {
  font-family: "Nelphim";
  src: local("Nelphim"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
}
@media only screen and (max-device-width: 768px) {
  .team-image-group {
    gap: 16px;
    padding-top: 0px;
 }
  .team-image-group .card .member-img-box {
    border-radius: 20px;
    padding: 16px;
 }
  .team-image-group .card .member-img-box .member-img {
    border-radius: 20px;
 }
  .about-img .about-img-group {
    gap: 16px;
    overflow: auto;
 }
  .about-img .about-img-group img {
    border-radius: 20px;
 }
  .vision-bg-image {
    min-height: 35vh;
 }
}
@media only screen and (max-device-width: 480px) {
  .section-team {
    padding: 60px 0px;
 }
  .section-about-group {
    display: block;
    max-width: 1366px;
    padding: 60px 0px;
    margin-left: auto;
    margin-right: auto;
 }
  .about-text {
    width: 100%;
    display: block;
    padding-bottom: 30px;
 }
  .about-text .section-about-1 {
    width: calc(100% - 60px);
    padding: 0px 30px;
 }
  .about-text .section-about-2 {
    width: calc(100% - 60px);
    padding: 30px 30px 0px 30px;
 }
  .about-img {
    width: calc(100% - 60px);
    display: block;
    padding: 0px 30px;
    overflow: auto;
 }
  .about-img .about-img-group {
    width: 100%;
    display: block;
    gap: 30px;
    overflow: auto;
 }
  .about-img .about-img-group img {
    width: 100%;
    border-radius: 10px;
    margin-bottom: 12px;
 }
  .about-img .about-img-group img:last-child {
    margin-bottom: 0px;
 }
  .section-vision {
    background-color: #7ca7c1;
    width: 100vw;
    color: #fcfcfc;
 }
  .section-vision-group {
    display: block;
    max-width: 1366px;
    margin-left: auto;
    margin-right: auto;
    position: relative;
    overflow: auto;
 }
  .vision-bg-image {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    background-size: calc(100vh - 80px);
    background-repeat: no-repeat;
    background-position: 15% bottom;
    min-height: 60vh;
 }
  .section-vision-1 {
    height: 100%;
    width: 100%;
    display: block;
    text-align: left;
 }
  .section-vision-1 .section-title {
    margin-top: 60px;
    padding-right: 0px;
    padding-left: 30px;
    text-transform: uppercase;
 }
  .section-vision-2 {
    width: 60%;
    display: block;
 }
  .section-vision-2 .section-detail {
    padding-left: 30px;
    padding-right: 0px;
    padding-top: 30px;
 }
  .section-vision-2 .section-button {
    margin-top: 60%;
    padding-left: 30px;
    padding-bottom: 20px;
 }
  .section-team-group {
    display: block;
    max-width: 1366px;
    padding: 0px 0px 0px 0px;
    margin-left: auto;
    margin-right: auto;
 }
  .section-team-title-group {
    width: 100%;
    display: block;
    align-items: center;
 }
  .section-team-title-group .section-team-title {
    width: calc(100% - 60px);
    padding: 0px 30px 20px;
 }
  .section-team-title-group .section-team-desc {
    width: calc(100% - 60px);
    padding: 0px 30px 16px;
 }
  .section-team-image {
    display: flex;
    max-width: 1366px;
    padding: 0px 0px 0px 0px;
    margin-left: auto;
    margin-right: auto;
 }
  .team-image-group {
    width: calc(100% - 60px);
    display: grid;
    grid-template-columns: 1fr;
    gap: 0px;
    overflow: auto;
    margin-left: auto;
    margin-right: auto;
 }
  .team-image-group .card:first-child {
    margin-top: 0px;
 }
  .team-image-group .card {
    width: 100%;
    display: block;
    margin-top: 20px;
 }
  .team-image-group .card .member-img-box {
    border-radius: 10px;
    background: #f7f7f7;
    display: flex;
    padding: 20px;
 }
  .team-image-group .card .member-img-box .member-img {
    width: 100%;
    border-radius: 10px;
 }
  .team-image-group .card .team-member-info {
    padding: 16px 20px 0px 20px;
    line-height: 1.5;
 }
}
`, "",{"version":3,"sources":["webpack://./src/assets/style/about_mobile.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,4EAAwE;AAC1E;;AAEA;EACE,yBAAyB;EACzB,gFAA2E;AAC7E;;AAEA;EACE,sBAAsB;EACtB,8EAAoE;AACtE;AACA;EACE;IACE,SAAS;IACT,gBAAgB;CACnB;EACC;IACE,mBAAmB;IACnB,aAAa;CAChB;EACC;IACE,mBAAmB;CACtB;EACC;IACE,SAAS;IACT,cAAc;CACjB;EACC;IACE,mBAAmB;CACtB;EACC;IACE,gBAAgB;CACnB;AACD;AACA;EACE;IACE,iBAAiB;CACpB;EACC;IACE,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;CACrB;EACC;IACE,WAAW;IACX,cAAc;IACd,oBAAoB;CACvB;EACC;IACE,wBAAwB;IACxB,iBAAiB;CACpB;EACC;IACE,wBAAwB;IACxB,2BAA2B;CAC9B;EACC;IACE,wBAAwB;IACxB,cAAc;IACd,iBAAiB;IACjB,cAAc;CACjB;EACC;IACE,WAAW;IACX,cAAc;IACd,SAAS;IACT,cAAc;CACjB;EACC;IACE,WAAW;IACX,mBAAmB;IACnB,mBAAmB;CACtB;EACC;IACE,kBAAkB;CACrB;EACC;IACE,yBAAyB;IACzB,YAAY;IACZ,cAAc;CACjB;EACC;IACE,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;CACjB;EACC;IACE,mDAA+C;IAC/C,mCAAmC;IACnC,4BAA4B;IAC5B,+BAA+B;IAC/B,gBAAgB;CACnB;EACC;IACE,YAAY;IACZ,WAAW;IACX,cAAc;IACd,gBAAgB;CACnB;EACC;IACE,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;CAC5B;EACC;IACE,UAAU;IACV,cAAc;CACjB;EACC;IACE,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;CACpB;EACC;IACE,eAAe;IACf,kBAAkB;IAClB,oBAAoB;CACvB;EACC;IACE,cAAc;IACd,iBAAiB;IACjB,wBAAwB;IACxB,iBAAiB;IACjB,kBAAkB;CACrB;EACC;IACE,WAAW;IACX,cAAc;IACd,mBAAmB;CACtB;EACC;IACE,wBAAwB;IACxB,sBAAsB;CACzB;EACC;IACE,wBAAwB;IACxB,sBAAsB;CACzB;EACC;IACE,aAAa;IACb,iBAAiB;IACjB,wBAAwB;IACxB,iBAAiB;IACjB,kBAAkB;CACrB;EACC;IACE,wBAAwB;IACxB,aAAa;IACb,0BAA0B;IAC1B,QAAQ;IACR,cAAc;IACd,iBAAiB;IACjB,kBAAkB;CACrB;EACC;IACE,eAAe;CAClB;EACC;IACE,WAAW;IACX,cAAc;IACd,gBAAgB;CACnB;EACC;IACE,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,aAAa;CAChB;EACC;IACE,WAAW;IACX,mBAAmB;CACtB;EACC;IACE,2BAA2B;IAC3B,gBAAgB;CACnB;AACD","sourcesContent":["@font-face {\n  font-family: \"Barlow\";\n  src: local(\"Barlow\"), url(\"../fonts/Barlow-Regular.woff\") format(\"woff\");\n}\n\n@font-face {\n  font-family: \"BarlowBold\";\n  src: local(\"BarlowBold\"), url(\"../fonts/Barlow-Medium.woff\") format(\"woff\");\n}\n\n@font-face {\n  font-family: \"Nelphim\";\n  src: local(\"Nelphim\"), url(\"../fonts/Nelphim.woff2\") format(\"woff2\");\n}\n@media only screen and (max-device-width: 768px) {\n  .team-image-group {\n    gap: 16px;\n    padding-top: 0px;\n }\n  .team-image-group .card .member-img-box {\n    border-radius: 20px;\n    padding: 16px;\n }\n  .team-image-group .card .member-img-box .member-img {\n    border-radius: 20px;\n }\n  .about-img .about-img-group {\n    gap: 16px;\n    overflow: auto;\n }\n  .about-img .about-img-group img {\n    border-radius: 20px;\n }\n  .vision-bg-image {\n    min-height: 35vh;\n }\n}\n@media only screen and (max-device-width: 480px) {\n  .section-team {\n    padding: 60px 0px;\n }\n  .section-about-group {\n    display: block;\n    max-width: 1366px;\n    padding: 60px 0px;\n    margin-left: auto;\n    margin-right: auto;\n }\n  .about-text {\n    width: 100%;\n    display: block;\n    padding-bottom: 30px;\n }\n  .about-text .section-about-1 {\n    width: calc(100% - 60px);\n    padding: 0px 30px;\n }\n  .about-text .section-about-2 {\n    width: calc(100% - 60px);\n    padding: 30px 30px 0px 30px;\n }\n  .about-img {\n    width: calc(100% - 60px);\n    display: block;\n    padding: 0px 30px;\n    overflow: auto;\n }\n  .about-img .about-img-group {\n    width: 100%;\n    display: block;\n    gap: 30px;\n    overflow: auto;\n }\n  .about-img .about-img-group img {\n    width: 100%;\n    border-radius: 10px;\n    margin-bottom: 12px;\n }\n  .about-img .about-img-group img:last-child {\n    margin-bottom: 0px;\n }\n  .section-vision {\n    background-color: #7ca7c1;\n    width: 100vw;\n    color: #fcfcfc;\n }\n  .section-vision-group {\n    display: block;\n    max-width: 1366px;\n    margin-left: auto;\n    margin-right: auto;\n    position: relative;\n    overflow: auto;\n }\n  .vision-bg-image {\n    background: url(../images/VisionMissionBG.webp);\n    background-size: calc(100vh - 80px);\n    background-repeat: no-repeat;\n    background-position: 15% bottom;\n    min-height: 60vh;\n }\n  .section-vision-1 {\n    height: 100%;\n    width: 100%;\n    display: block;\n    text-align: left;\n }\n  .section-vision-1 .section-title {\n    margin-top: 60px;\n    padding-right: 0px;\n    padding-left: 30px;\n    text-transform: uppercase;\n }\n  .section-vision-2 {\n    width: 60%;\n    display: block;\n }\n  .section-vision-2 .section-detail {\n    padding-left: 30px;\n    padding-right: 0px;\n    padding-top: 30px;\n }\n  .section-vision-2 .section-button {\n    margin-top: 60%;\n    padding-left: 30px;\n    padding-bottom: 20px;\n }\n  .section-team-group {\n    display: block;\n    max-width: 1366px;\n    padding: 0px 0px 0px 0px;\n    margin-left: auto;\n    margin-right: auto;\n }\n  .section-team-title-group {\n    width: 100%;\n    display: block;\n    align-items: center;\n }\n  .section-team-title-group .section-team-title {\n    width: calc(100% - 60px);\n    padding: 0px 30px 20px;\n }\n  .section-team-title-group .section-team-desc {\n    width: calc(100% - 60px);\n    padding: 0px 30px 16px;\n }\n  .section-team-image {\n    display: flex;\n    max-width: 1366px;\n    padding: 0px 0px 0px 0px;\n    margin-left: auto;\n    margin-right: auto;\n }\n  .team-image-group {\n    width: calc(100% - 60px);\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 0px;\n    overflow: auto;\n    margin-left: auto;\n    margin-right: auto;\n }\n  .team-image-group .card:first-child {\n    margin-top: 0px;\n }\n  .team-image-group .card {\n    width: 100%;\n    display: block;\n    margin-top: 20px;\n }\n  .team-image-group .card .member-img-box {\n    border-radius: 10px;\n    background: #f7f7f7;\n    display: flex;\n    padding: 20px;\n }\n  .team-image-group .card .member-img-box .member-img {\n    width: 100%;\n    border-radius: 10px;\n }\n  .team-image-group .card .team-member-info {\n    padding: 16px 20px 0px 20px;\n    line-height: 1.5;\n }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
